export interface EmbeddedDuplicationInfo {
  scriptCount: number;
}

export const detectEmbeddedDuplication = (): EmbeddedDuplicationInfo => {
  if (typeof document === 'undefined') {
    return { scriptCount: 0 };
  }
  try {
    const scriptCount = document.querySelectorAll('script[gd-company-id]').length;
    return { scriptCount };
  } catch {
    return { scriptCount: 0 };
  }
};
